import { render, staticRenderFns } from "./Commande.vue?vue&type=template&id=2041ca45&scoped=true"
import script from "./Commande.vue?vue&type=script&lang=js"
export * from "./Commande.vue?vue&type=script&lang=js"
import style0 from "./Commande.vue?vue&type=style&index=0&id=2041ca45&prod&scoped=true&lang=css"
import style1 from "./Commande.vue?vue&type=style&index=1&id=2041ca45&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2041ca45",
  null
  
)

export default component.exports